import { render, staticRenderFns } from "./AppBarDocs.vue?vue&type=template&id=672636bd&"
import script from "./AppBarDocs.vue?vue&type=script&lang=js&"
export * from "./AppBarDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672636bd')) {
      api.createRecord('672636bd', component.options)
    } else {
      api.reload('672636bd', component.options)
    }
    module.hot.accept("./AppBarDocs.vue?vue&type=template&id=672636bd&", function () {
      api.rerender('672636bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/AppBarDocs.vue"
export default component.exports